import React from 'react'
import { CircularProgressBar } from 'components/library'

const PageProgress = props => {
  const currentPage = 1
  const totalPages = 1
  const percentage = Math.floor(currentPage/totalPages*100)

  return (
    <div style={{ margin: '0 4rem 0 -3rem' }}>
      <CircularProgressBar
        sqSize={props.size}
        strokeWidth={props.stroke}
        label={`${currentPage}/${totalPages}`}
        percentage={percentage} />
    </div>
  )
}

PageProgress.defaultProps = {
  size: 60,
  stroke: 6
}

export default PageProgress


// WEBPACK FOOTER //
// ./src/components/library/progressbar/PageProgress.js